// extracted by mini-css-extract-plugin
export default {"navItem":"NavItem_navItem__kbHQ0","active":"NavItem_active__8-MX9"};